import { createFileRoute } from '@tanstack/react-router'
import AmenitiesPage from '@/features/amenities/components/amenities-page'

export const Route = createFileRoute('/_authenticated/dashboard/amenities/')({
  component: AmenitiesPage,
})
